var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"two-step"},[_c('div',{staticClass:"two-step-header"},[_c('div',{staticClass:"autodesk-logo-header"},[_c('img',{staticClass:"autodesk-logo",attrs:{"src":require("../assets/images/employeehub-logo.svg")},on:{"click":function($event){return _vm.navigateToHome()}}})])]),_c('two-step-body'),_c('two-step-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }